import { createStoryStreamAppConfig } from './storystream-fa-config/storystream-fa-config';
import { defaultAppConfig } from './default-app-config';
import { FeatureAppNames } from './app-constants';
import { ModelOverviewIntegratorOptions } from './create-options-from-query-params';

const getCreateFunctionInstance = (featureAppName: string | undefined) => {
  switch (featureAppName) {
    case FeatureAppNames.DEFAULT as string:
      return defaultAppConfig.createFunctionInstance;
    default:
      return createStoryStreamAppConfig;
  }
};

export const getConfigsFeatureApp = ({
  featureAppName,
  ...props
}: ModelOverviewIntegratorOptions) => {
  const createFunctionInstance = getCreateFunctionInstance(featureAppName);
  return createFunctionInstance(props);
};

export const contentFeatureAppMap = {
  [FeatureAppNames.DEFAULT]: defaultAppConfig.appContent,
};
